/**
 * @cloudpearl/audio — 100% procedural Web Audio sound design + generative music for Cloud Pearl.
 *
 * No audio files, no dependencies; only the standard Web Audio node set, so it also runs on
 * react-native-audio-api (pass its context via `createContext`).
 *
 *   const audio = createAudioEngine();
 *   addEventListener('pointerdown', () => audio.unlock());   // must be inside a user gesture
 *   audio.setTheme(map.audioTheme);
 *   // every frame:  audio.update(frame, dt);
 *   // on events:    audio.play({ type: 'land', quality: 'perfect', combo, impact });
 */
import { SilentAudioEngine, WebAudioEngine, canCreateAudio } from './engine';
import type { AudioEngine, AudioEngineOptions } from './types';

export type {
  AudioEngine,
  AudioEngineOptions,
  AudioEvent,
  AudioFrame,
  AudioState,
  AudioVolumes,
  CrashMaterial,
} from './types';
export { THEMES, type ThemeDef } from './themes';

/** Create the engine. Returns a silent no-op engine when no AudioContext is available. */
export function createAudioEngine(options?: AudioEngineOptions): AudioEngine {
  if (!canCreateAudio(options)) return new SilentAudioEngine();
  return new WebAudioEngine(options);
}
